// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1872) return "static/chunks/1872-44fe53a1bc1082d1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2831":"b5c69090","4228":"d88ffec7"}[chunkId] || chunkId) + "." + {"1649":"f228b6658541ee79","1652":"3d1bde8ee5f244dc","2831":"6b68c1ba82c2eaed","2840":"e4f9219d3c28872a","3081":"37aa643df02fcf4d","4180":"082edb19dee0d15d","4228":"41e7f8c992199219","5164":"8465a4c4e8c15253","9367":"298afb4d93cbdd4c"}[chunkId] + ".js";
};